import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

export const useCanUpsellPayroll = () => {
  const { moduleAvailabilities } = useModuleAvailabilities()

  const hasAnyPayrollModulesAvailable = moduleAvailabilities.some(
    (module) => ['payroll', 'compensations'].includes(module.id) && module.available
  )

  const canUpsellPayroll = !hasAnyPayrollModulesAvailable

  return {
    canUpsellPayroll,
  }
}
